import { getDimensions } from '@apps/card/utils';
import { ChoiceGroup, useCustomizationContext } from '@apps/card/routes/CardCustomizer';
import React from 'react';
import { formatCardSizeName, useCardSizeLabels } from '@apps/card/utils/cardSizeName';
import { useStationeryProductPricingContext } from '@apps/card/components/ProductUIConfig/utils/useStationeryProductPricingContext';
import { useTranslation } from '@shared/core';

// The interactive size picker merged into the PDP's ProductSizeSelector; only
// the customizer's read-only display remains here.
export const ReadOnlySizeChoiceGroup = () => {
  // Rendered inside the paper customizer's pricing provider — the active
  // PRODUCT distinguishes a magnet from a postcard on the same template.
  const { activeProduct } = useStationeryProductPricingContext();
  const { tq } = useTranslation('stationery');
  const [cardDimensions] = useCustomizationContext(draft => getDimensions(draft.config.card));
  const [category] = useCustomizationContext(draft => draft.stationeryTemplateCategory);
  const sizeLabels = useCardSizeLabels();
  const cardSizeText = formatCardSizeName(category, cardDimensions.width, cardDimensions.height, sizeLabels, activeProduct.productType);

  return (
    <ChoiceGroup
      title={tq`Size`}
      value={cardSizeText}
      textTransform="none"
    />
  );
};
